import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FadeUp, SectionTag } from "../components/motion";
import { SOLUTIONS } from "../data/content";
import useSEO from "../hooks/useSEO";

export default function Solutions() {
  useSEO(
    "IT Solutions & Services — CCTV Camera, Networking, Software, Automation | SGSNet Patna",
    "Explore SATI Global Systems (SGSNet) solutions in Patna: CCTV & surveillance cameras, IT infrastructure, networking, software development, business process automation, chip-level maintenance, IT consultancy and project management."
  );
  return (
    <main data-testid="solutions-page" className="pt-16 sm:pt-24 pb-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <FadeUp><SectionTag>Solutions</SectionTag></FadeUp>
        <FadeUp delay={0.1}>
          <h1 className="mt-5 font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 leading-[1.08] max-w-3xl">
            Capability across the <span className="text-blue-600">full technology stack.</span>
          </h1>
        </FadeUp>
        <FadeUp delay={0.2}>
          <p className="mt-6 max-w-2xl text-base sm:text-lg text-slate-600 leading-relaxed">
            Eight integrated disciplines — deployable individually, engineered to work as one.
          </p>
        </FadeUp>

        <div className="mt-16 grid sm:grid-cols-2 gap-5">
          {SOLUTIONS.map((s, i) => (
            <FadeUp key={s.slug} delay={(i % 2) * 0.1}>
              <Link to={`/solutions/${s.slug}`} data-testid={`solutions-card-${s.slug}`}
                className="group relative flex gap-6 bg-panel border border-slate-200 rounded-2xl p-7 hover:border-blue-600/40 hover:bg-panelhover transition-colors duration-300 overflow-hidden h-full">
                <div className="absolute -bottom-6 -right-2 font-heading font-black text-8xl text-slate-200 select-none leading-none">{s.num}</div>
                <div className="shrink-0 w-12 h-12 rounded-lg bg-blue-600/10 border border-blue-600/30 flex items-center justify-center">
                  <s.icon size={22} className="text-blue-600" strokeWidth={1.6} />
                </div>
                <div className="relative">
                  <h2 className="font-heading text-xl font-semibold text-slate-900 group-hover:text-blue-700 transition-colors">{s.title}</h2>
                  <p className="mt-2 text-sm text-slate-500 leading-relaxed">{s.short}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-[0.15em] text-blue-600/80 group-hover:text-blue-600 transition-colors">
                    View capability <ArrowUpRight size={13} />
                  </span>
                </div>
              </Link>
            </FadeUp>
          ))}
        </div>
      </div>
    </main>
  );
}
